exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-header{border:2px solid #000}.btn-header.active{color:#fff;background:#000}", ""]);

// exports
